import {
  createApiFactory,
  createComponentExtension,
  createPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { EndOfLifeDateClient } from './apis/EndOfLifeDateClient';
import { eolApiRef } from './apis/EolApi';

export const frameworkVersionsPlugin = createPlugin({
  id: 'framework-versions',
  apis: [
    createApiFactory({
      api: eolApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: deps => new EndOfLifeDateClient(deps),
    }),
  ],
});

export const EntityFrameworkVersionsCard = frameworkVersionsPlugin.provide(
  createComponentExtension({
    name: 'EntityFrameworkVersionsCard',
    component: {
      lazy: () =>
        import('./components/EntityFrameworkVersionsCard').then(
          m => m.EntityFrameworkVersionsCard,
        ),
    },
  }),
);
